import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/Logo";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    window.history.replaceState(null, "", window.location.pathname);
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        applyAuth(data);
        navigate(data.user.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch (e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, applyAuth]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-white">
      <Logo />
      <div className="h-8 w-8 rounded-full border-2 border-[#5aa469] border-t-transparent animate-spin" />
      <p className="text-sm text-gray-500">Accesso in corso…</p>
    </div>
  );
}
